import { useQuery, useQueryClient } from "@tanstack/react-query";
import Drawer from "../../../../drawer/Drawer";
import Tabs from "../../../../elements/Tabs";
import CancelorRefund from "../CancelorRefund";
import ManageOrder from "../ManageOrder";
import { orderDetails } from "../../../../../services/orderService";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Skeleton from "../../../../loader/Skeleton";
import { t } from "i18next";

const ManageOrderDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const queryClient = useQueryClient();
  const { selectedOrganizationDetails } = useSelector(
    (state) => state?.organization
  );
  const user_role = selectedOrganizationDetails?.data?.verificationData?.role;

  const { data: details, isLoading } = useQuery({
    queryKey: ["details", data?._id],
    queryFn: async () => {
      const res = await orderDetails({ id: data?._id });

      const buyer_name = res?.data?.billingInfo
        ?.filter((buyer) =>
          ["First Name", "Last Name"].includes(buyer?.question)
        )
        ?.map((buyer) => `${buyer?.answers || ""}`.trim())
        .join(" ");
      const buyer_email = res?.data?.billingInfo
        ?.filter((buyer) => ["Email"].includes(buyer?.question))
        ?.map((buyer) => `${buyer?.answers || ""}`.trim())
        .join(" ");

      return {
        ...res,
        data: {
          billing_info: { buyer_name, buyer_email },
          ...res?.data,
          orderItemData: res?.data?.orderItemData?.map((item) => ({
            ...item,
            remainingRefundableAmount:
              (item?.finalPrice || 0) - (item?.refund?.refundAmount || 0),
          })),
        },
      };
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["details", data?._id] });
    };
  }, []);

  const tabItems = [
    {
      label: t("Details"),
      icon: "",
      content: (
        <ManageOrder
          getResponse={getResponse}
          close={close}
          details={details}
        />
      ),
    },
    ...(user_role !== "promoter"
      ? [
          {
            label: t("Cancel/Refund"),
            icon: "",
            content: (
              <CancelorRefund
                getResponse={getResponse}
                close={close}
                details={details?.data}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl6"}
      size={"xl6"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          {t("Order details")}
        </span>
      }
      subtitle={t("View order details and information bellow")}
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-auto scrollbar flex bg-gradient-to-tr from-[#f5faff] via-white to-[#fef6f9]"
    >
      {isLoading ? (
        <Skeleton width={"100%"} height={"100%"} />
      ) : (
        <Tabs
          items={tabItems}
          contentClass={"w-full"}
          tabsClass="gap-3 p-5 flex items-center gap-4 rounded-lg border-t border-slate-100 shadow-lg"
          tabClass={
            "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
          }
          activeTabClass={"bg-primary border border-primary !text-white"}
          tablistsClass="p-5 pb-0 sticky top-0 z-10 bg-white"
        />
      )}
    </Drawer>
  );
};

export default ManageOrderDrawer;
